import {
    FETCH_WORKKARD_OWNER_LIST_REQUEST,
    CHANGE_WORKKARD_OWNER_REQUEST,
    CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE,
    FETCH_ACTIVITY_OWNER_LIST_REQUEST,
    CHANGE_ACTIVITY_OWNER_REQUEST,
    BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST,
    CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE,
    BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST,
    BULK_CHANGE_ACTIVITY_OWNER_REQUEST
} from "../ChangeOwner/actionConstants";

export const getWorkkardOwners = (workkardId) => ({
    type: FETCH_WORKKARD_OWNER_LIST_REQUEST,
    payload:workkardId
});

export const changeWorkkardOwner = (payload) => ({
    type: CHANGE_WORKKARD_OWNER_REQUEST,
    payload
});

export const resetChangeWorkkardOwnerState = () => ({
    type:CHANGE_WORKKARD_OWNER_RESET_TO_INITIAL_STATE
});

export const validateWorkkardIds = (payload) => ({
    type: BULK_VALIDATE_WORKKARD_IDS_CHANGE_OWNER_REQUEST,
    payload
});

export const getActivityOwners = (activityId) => ({
    type: FETCH_ACTIVITY_OWNER_LIST_REQUEST,
    payload:activityId
});

export const changeActivityOwner = (payload) => ({
    type: CHANGE_ACTIVITY_OWNER_REQUEST,
    payload
});

export const resetChangeActivityOwnerState = () => ({
    type:CHANGE_ACTIVITY_OWNER_RESET_TO_INITIAL_STATE
})

export const bulkValidateChangeActivityOwner = (payload) => ({
    type: BULK_VALIDATE_ACTIVITY_IDS_CHANGE_OWNER_REQUEST,
    payload
});

export const bulkChangeActivityOwner = (payload) => ({
    type: BULK_CHANGE_ACTIVITY_OWNER_REQUEST,
    payload
})